import React, { Component } from 'react';
import Loc from './addedit/loc'
import Farm from './addedit/farm'
import Staff from './addedit/staff'
import './create.css'
import Batch from './addedit/batch';
import ProductInit from './addedit/productInit';
import Swine from './addedit/swine';
import auth from '../../utils/auth';

export default class CreateFarm extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isFirst: false,
      current: null,
      type: '',
      currentNode: null
    }
  }
  setCreateState = (obj, callback) => {
    // 子组件修改父组件的值
    this.setState({...obj}, () => {
      callback && callback(this.state)
    })
  };
  doSave = () => {
    console.log('点击了完成')
  };
  UNSAFE_componentWillMount() {
    //
    auth.setCookie('ISFIRST', true);
  }

  componentDidMount() {
    let {pathname} = this.props.location;
    const {isFirst} = this.props;
    let current = pathname.split('/')[2].split('_')[0];
    let type = pathname.split('_')[1].split('/')[0];
    this.setState({
      current,
      type,
      isFirst,
      currentNode: <Farm {...this.props}/>
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let pathname = nextProps.location.pathname;
    const {isFirst} = this.props;
    if (pathname === '/setting') {
      return;
    }
    let current = pathname.split('/')[2].split('_')[0];
    let type = pathname.split('_')[1].split('/')[0];
    this.setState({
      current,
      type,
      isFirst
    });
  }
  render() {
    let {current, type} = this.state;
    return (
      <React.Fragment>
        <div className={type === 'edit'? 'settings-content-edit': 'settings-content'}>
          {
            current === 'farm'
            ? <Farm {...this.props} /> : null
          }
          {
            current === 'loc' && <Loc
                {...this.props}
                                 />
          }
          {
            current === 'batch' && <Batch
                {...this.props}
                                   />
          }
          {
            current === 'staff' && <Staff
                {...this.props}
                                   />
          }
          {
            current === 'product' && <ProductInit
                {...this.props}
                                     />
          }
          {
            current === 'swine' && <Swine
                {...this.props}
                                   />
          }

        </div>
      </React.Fragment>

  )
 }
}
